import React from 'react';
import dataKodeEtik from './dataKodeEtik.json';

const EtikaPerusahaan = () => {
  return (
    <section className="bg-white pt-10 px-4">
      <div className="container mx-auto">
        
        {/* Header Section */}
        <div className="mb-12 text-center" data-aos="fade-down">
          <h2 className="text-3xl font-bold text-[#005da2] mb-6">
            Kode Etik
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed text-justify">
            PT Len Telekomunikasi Indonesia memperlakukan karyawan secara setara (fair) dan tidak membedakan suku, agama, ras dan antar golongan dalam segala aspek. PT Len Telekomunikasi Indonesia menyadari bahwa karyawan mempunyai peranan dan kedudukan yang sangat penting sebagai pelaku dan tujuan Perusahaan. Oleh karena itu setiap karyawan dituntut dapat berpartisipasi dan berperan aktif dengan jalan meningkatkan produksi dan produktivitas kerja melalui hubungan yang dinamis, harmonis, selaras, serasi dan seimbang antara Perusahaan dan karyawan.
          </p>
          <h3 className="text-lg font-semibold text-gray-800 text-justify py-2">
            Dalam melaksanakan etika ini, Perusahaan:
          </h3>
                <p className="text-lg text-gray-700 leading-relaxed text-justify pl-6 py-2">
                    1.	Mengacu kepada Perjanjian Kerja Bersama (PKB) dalam hal kesejahteraan karyawan, penyediaan sarana dan prasarana kerja.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed text-justify pl-6 py-2">
                    2.	Melaksanakan Perjanjian Kerja Bersama (PKB) secara konsisten.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed text-justify pl-6 py-2">
                    3.	Memastikan setiap karyawan telah mendapat sosialisasi isi PKB.
                </p>
        </div>

        {/* Render Section dari JSON */}
        {dataKodeEtik.map((item, index) => (
          <div key={index} className="mb-12 pl-6 py-2" data-aos="fade-up">
            {/* Judul Kategori (h3) */}
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              {item.title}
            </h3>
            
            {/* Intro */}
            {Array.isArray(item.intro) ? (
            item.intro.map((text, iIdx) => (
              <p key={iIdx} className="text-lg text-gray-700 leading-relaxed text-justify mb-4">
                {text}
              </p>
            ))
          ) : (
            <p className={`text-lg text-gray-700 leading-relaxed text-justify ${item.points ? 'mb-4' : ''}`}>
              {item.intro}
            </p>
          )}
            
            {/* List muncul klo ada data points */}
            {item.points && (
              <ol className="list-decimal ml-6 space-y-3 text-lg text-gray-700 leading-relaxed mt-4">
                {item.points.map((point, pIdx) => (
                  <li key={pIdx} className="pl-2 text-justify">
                    {point}
                  </li>
                ))}
              </ol>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default EtikaPerusahaan;